import React, { useEffect, useMemo, useState } from 'react';
import { Button } from 'reactstrap';

const QtyCounter = ({ onChange, min = 1, max = 9999, value = 0, size = 'sm' }) => {
  const [qty, setQty] = useState(value);

  useEffect(() => {
    setQty(Math.max(...[value, min]));
  }, [value, min]);

  const updateQty = (type) => {
    let nextQty = qty + 1;

    if (type === 'decrease') {
      nextQty = qty - 1;
    }

    if ((type === 'increase' && nextQty > max) || (type === 'decrease' && nextQty < min)) return;

    setQty(nextQty);
    onChange(nextQty);
  };

  const disabledDecrese = useMemo(() => {
    return qty <= min;
  }, [qty, min]);

  const disabledIncrease = useMemo(() => {
    return qty >= max;
  }, [qty, max]);

  return (
    <div className="d-flex align-items-center counter">
      <Button
        className="counter__btn"
        onClick={() => updateQty('decrease')}
        disabled={disabledDecrese}>
        <i className="fa fa-minus" />
      </Button>
      <div className="counter__text">{qty}</div>
      <Button
        className="counter__btn"
        onClick={() => updateQty('increase')}
        disabled={disabledIncrease}>
        <i className="fa fa-plus" />
      </Button>
    </div>
  );
};

export default QtyCounter;
